const Loader = ({ fullScreen = false, centered = false }) => {
  if (centered) {
    return (
      <div className="absolute inset-0 bg-white/40 backdrop-blur-[2px] z-50 flex items-center justify-center">
        <div className="loader7 text-primary">
          <div className="inner-ring"></div>
        </div>
      </div>
    );
  }

  return (
    <div className={fullScreen ? "loader7-container backdrop-blur-[2px]" : "loader7-container-modular"}>
      <div className="loader7 text-primary">
        <div className="inner-ring"></div>
      </div>
    </div>
  );
};

export default Loader;
